module.exports = __webpack_public_path__ + "assets/img/83e3b97524763c37faf1c42a4a363a90.png";